import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import IconWithTooltip from "components/IconWithTooltip";
import {
  BLANK_CATEGORY_NAME_ERROR,
  CATEGORY_NAME_DUPLICATE_ERROR,
} from "constants/discovery";
import { modalTypes } from "constants/types";
import { ReactComponent as ErrorIcon } from "icons/dictionary/info-error.svg";
import PropTypes from "prop-types";
import { useId, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideModal } from "slices/app/actions/modals";
import { createNewCategory } from "slices/discovery/actions/actionButtons";
import { selectAddToDictPanel } from "slices/discovery/selectors";

const CreateNewCategoryModal = ({ insertAt }) => {
  const dispatch = useDispatch();
  const nameId = useId();
  const descriptionId = useId();

  const [name, setName] = useState("");
  const [wasEdited, setWasEdited] = useState(false);
  const [nameError, setNameError] = useState(null);
  const [description, setDescription] = useState("");
  const {
    dictionary: { categories },
  } = useSelector(selectAddToDictPanel);

  const handleNameChange = ({ target: { value } }) => {
    if (!wasEdited) {
      setWasEdited(true);
    }

    setName(value);
    setNameError("");
  };

  const handleNameBlur = () => {
    if (name.trim() === "") {
      setNameError(BLANK_CATEGORY_NAME_ERROR);
    } else if (categories.some((category) => category.name === name)) {
      setNameError(CATEGORY_NAME_DUPLICATE_ERROR);
    }
  };

  const handleDescriptionChange = ({ target: { value } }) => {
    setDescription(value);
  };

  const handleCreateClick = () => {
    dispatch(createNewCategory(name, description, insertAt));
  };

  const handleCancelClick = () => {
    dispatch(hideModal(modalTypes.CREATE_NEW_CATEGORY));
  };

  return (
    <Modal
      show
      centered
      backdrop
      data-test="create-new-category-modal"
      className="fade-in create_new_entry_modal"
      onDismiss={handleCancelClick}
    >
      <Modal.Header>
        <b>Create a new Category</b>
      </Modal.Header>
      <Modal.Body>
        <label htmlFor={nameId}>Category Name</label>
        <div className="create_new_entry_modal__name">
          <input
            type="text"
            id={nameId}
            autoFocus
            data-testid="name-input"
            value={name}
            onChange={handleNameChange}
            onBlur={handleNameBlur}
          />

          {nameError && (
            <IconWithTooltip
              icon={<ErrorIcon width={16} height={16} />}
              tooltipText={nameError}
            />
          )}
        </div>
        <label htmlFor={descriptionId}>Category Description</label>
        <textarea
          id={descriptionId}
          data-testid="description-input"
          rows={4}
          value={description}
          className="create_new_entry_modal__description"
          onChange={handleDescriptionChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancelClick}>
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          disabled={!wasEdited || nameError}
          onClick={handleCreateClick}
        >
          Create
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

CreateNewCategoryModal.propTypes = {
  insertAt: PropTypes.number.isRequired,
};

export default CreateNewCategoryModal;
